import { render } from "./baseLayout.vue?vue&type=template&id=4b2f73f9"
import script from "./baseLayout.vue?vue&type=script&lang=js"
export * from "./baseLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__